/**
 * Returns a taskId based upon a trqkSongId for use with the useUploadTrack hook.
 * @params trqkSongId a trqkSong.id
 */
export const getUseUploadTrackTaskId = (trqkSongId: string): string =>
    `use-upload-track-task-${trqkSongId}`;
